import { Flags } from 'graphql/flags.generated'

export const BACK_TO_ORIGIN_DEFAULT_LABEL = 'Voltar'

export const BACK_TO_ORIGIN_LABELS = {
  prontuarioFamiliar: 'Voltar ao prontuário familiar',
  cadastroDoImovel: 'Voltar ao cadastro do imóvel',
  mapaDoTerritorio: 'Voltar ao mapa do território',
} as const

export type BackToOriginKey = keyof typeof BACK_TO_ORIGIN_LABELS

export const BACK_TO_ORIGIN_FLAGGED_BY: Partial<Record<BackToOriginKey, Flags[]>> = {
  prontuarioFamiliar: ['PILOTO_PRONTUARIO_FAMILIAR_ENABLED'],
  mapaDoTerritorio: ['MAPA_TERRITORIO_ENABLED'],
}

export interface BackToOriginUrlParams {
  backToOriginUrl?: string
  backToOriginKey?: string
}
